/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { userSuggestionSchema } from './userSuggestionSchema';

export const userSuggestionsResponseSchema = z.object({
  get results() {
    return z.array(userSuggestionSchema);
  },
});
